export default __webpack_public_path__ + "static/O0314-206b362b3bf2a69fc5acf29b990c9d5b.png";